import React from 'react';
import { Heart, ActivitySquare, Users } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

export default function ProfessionalProfile() {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="bg-white rounded-[2.5rem] p-8 md:p-16 shadow-xl border border-gray-100 flex flex-col lg:flex-row items-center gap-12 overflow-hidden relative">

                    {/* Fundo decorativo */}
                    <div className="absolute top-0 right-0 w-64 h-64 bg-conectiva-lime/10 rounded-full blur-3xl -mr-20 -mt-20"></div>

                    <div className="lg:w-1/2 z-10">
                        <ScrollReveal>
                            <h2 className="text-3xl md:text-4xl font-extrabold text-conectiva-navy mb-6">
                                Mais do que uma profissão, <span className="text-conectiva-lime">uma vocação</span>
                            </h2>
                            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                                Nosso curso é preparado para formar técnicos que entendem o processo saúde-doença com um olhar político, social e humano. Você será o profissional capaz de:
                            </p>

                            <div className="space-y-6">
                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 mt-1">
                                        <Heart className="text-conectiva-lime" size={24} />
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-gray-900 text-lg">Cuidado Humanizado</h4>
                                        <p className="text-gray-600 text-sm mt-1">Atendimento às necessidades básicas de saúde dos pacientes com respeito e dedicação em todas as faixas etárias.</p>
                                    </div>
                                </div>

                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 mt-1">
                                        <ActivitySquare className="text-conectiva-lime" size={24} />
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-gray-900 text-lg">Promoção e Reabilitação</h4>
                                        <p className="text-gray-600 text-sm mt-1">Ações de prevenção de doenças, recuperação e reabilitação para melhorar a qualidade de saúde regional.</p>
                                    </div>
                                </div>

                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 mt-1">
                                        <Users className="text-conectiva-lime" size={24} />
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-gray-900 text-lg">Assistência Qualificada</h4>
                                        <p className="text-gray-600 text-sm mt-1">Atendimento clínico e cirúrgico com forte compromisso ético e visão crítica, sob supervisão segura.</p>
                                    </div>
                                </div>
                            </div>
                        </ScrollReveal>
                    </div>

                    <div className="lg:w-1/2 z-10 w-full relative">
                        <ScrollReveal delay={0.3}>
                            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                                <img
                                    src="https://images.unsplash.com/photo-1551076805-e1869033e561?auto=format&fit=crop&q=80"
                                    alt="Profissional de Enfermagem"
                                    className="w-full h-[500px] object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-conectiva-navy/80 to-transparent flex items-end p-8">
                                    <p className="text-white text-xl font-medium leading-snug transform transition-transform duration-500 hover:scale-105 hover:text-conectiva-lime">
                                        "Comprometido com a proteção e promoção da vida."
                                    </p>
                                </div>
                            </div>
                        </ScrollReveal>
                    </div>

                </div>
            </div>
        </section>
    );
}
